import styled from 'styled-components';
import { ContractTraceabilityDetails } from './ContractTraceabilityHeader';

export const ContractDetails = styled(ContractTraceabilityDetails)`
  grid-template-columns: repeat(2, minmax(10.625em, 1fr));
`;

export default ContractDetails;
